import { Component, OnInit } from '@angular/core';
import { SearchDTO, SearchType } from '../../models/analys-resultat';

@Component({
    selector: 'app-search-params',
    templateUrl: './search-params.component.html',
    styleUrl: './search-params.component.scss',
    standalone: false
})
export class SearchParamsComponent implements OnInit {

  protected searchParams!: SearchDTO;
  protected searchTypes = SearchType;

  ngOnInit(): void {
    this.searchParams = JSON.parse(localStorage.getItem('searchParams') as any);
  }

  protected reverseMapGender(genderNumber: string) {
    return genderNumber === '1' ? 'Man' : genderNumber === '2' ? 'Kvinna' : 'Okänt';
  }

  protected getGenderText(genders: string[]) {
    return genders.map(gender => this.reverseMapGender(gender)).join(', ')
  }
}
